<template>
	<div>
		<span v-if="!enabled" class="btn btn-light" @click="enable">{{ _lang('Custom font')}}</span>

		<div class="modal modal-active modal-center	" v-if="enabled">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<div class="modal-title">
							{{ _lang("Custom font") }}
						</div>
						<span class="close" @click="close">&times;</span>
					</div>
					<div class="modal-body">
						<p class="info">
							{{ _lang("Select only woff2 fonts (optimized for web). To convert TTF to WOFF2, use") }}
							<a
								href="https://www.fontsquirrel.com/tools/webfont-generator"
								target="_blank"
								>Font Squirrel</a
							>.
						</p>
						<div class="grid">
							<input
								type="text"
								class="form-control"
								v-model="uploaded.name"
								placeholder="Nome da fonte"
							/>
							<select
								v-model="uploaded.weight"
								class="form-control"
							>
								<option value="100">100</option>
								<option value="200">200</option>
								<option value="300">300</option>
								<option value="regular">regular</option>
								<option value="500">500</option>
								<option value="600">600</option>
								<option value="700">700</option>
								<option value="800">800</option>
								<option value="900">900</option>
							</select>
							<div>
								<div class="custom-file">
									<input
										type="file"
										accept=".woff2"
										class="custom-file-input"
										@change="
											onFileChange(
												$event,
												uploaded,
												'filename'
											)
										"
									/>
									<label class="custom-file-label">{{
										label
									}}</label>
								</div>
							</div>
						</div>
						<span class="btn btn-primary" @click="choose">{{
							_lang("Save")
						}}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.grid {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-gap: 10px;
	margin-bottom: 10px;
}
.btn {
	width: 100%;
}
.info {
	font-size: 0.8em;
	color: #999;
}
span {
	cursor: pointer;
}
</style>
<script>
import componentFunctions from "../mixin.components.js";

export default {
	name: "custom-font-select",
	props: ["value", "placeholder"],
	mixins: [componentFunctions],
	data() {
		return {
			enabled: false,
			label:'Upload',
			uploaded: {
				filename: "",
				name: "",
				weight: "regular"
			}
		};
	},
	watch: {
		"uploaded.filename": function() {
			this.label = this.uploaded.filename.split("/").pop();
			this.uploaded.name = this.label
				.split(".")
				.shift()
				.replace(/-\d+$/, "");
		}
	},
	methods: {
		close() {
			this.enabled = false;
		},
		enable() {
			this.enabled = true;
		},

		choose() {
			var font = {
				family: this.uploaded.name,
				variants: [this.uploaded.weight],
				filename: this.uploaded.filename
			};

			this.$emit("input", font);
			this.$emit("add", font);
			this.close();
		}
	},
	mounted() {},
	destroyed() {}
};
</script>
